exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1j7cMKJzK3hDG-6d1x8z6x{font-size:14px;color:\"[theme:neutralSecondary, default:#666666]\"}._1j7cMKJzK3hDG-6d1x8z6x.NCCd4mtRtnDhwXkQV3Z_P{color:#c50e2e}._1XTgRlvIFVAMWCwk3N1Mrd{font-size:12px;font-weight:400;color:\"[theme:themePrimary, default:#0078D4]\";cursor:pointer}html[dir] ._1XTgRlvIFVAMWCwk3N1Mrd{background:transparent}html[dir=ltr] ._1lAZM-j0_dTiprJU8qtsOC{padding-right:5px}html[dir=rtl] ._1lAZM-j0_dTiprJU8qtsOC{padding-left:5px}._2A5MU0_Ldq3YiUz9_7eSp0{position:relative;top:-1px}", ""]);
// Exports
exports.locals = {
	"sharingTipIcon": "_1j7cMKJzK3hDG-6d1x8z6x",
	"error": "NCCd4mtRtnDhwXkQV3Z_P",
	"actionButton": "_1XTgRlvIFVAMWCwk3N1Mrd",
	"paddingRight": "_1lAZM-j0_dTiprJU8qtsOC",
	"divider": "_2A5MU0_Ldq3YiUz9_7eSp0"
};